import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../api";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=logged out
  const [module, setModuleState] = useState(localStorage.getItem("module") || "tous");

  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) { setUser(null); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  const completeLogin = useCallback((data) => {
    localStorage.setItem("token", data.token);
    if (data.device_token) localStorage.setItem("device_token", data.device_token);
    setUser(data.user);
    if (data.user.role === "employe" && data.user.specialty) {
      setModuleState(data.user.specialty);
      localStorage.setItem("module", data.user.specialty);
    }
    return data.user;
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", {
      email, password, device_token: localStorage.getItem("device_token"),
    });
    if (r.data.requires_code) return r.data; // code de connexion par email requis
    completeLogin(r.data);
    return r.data;
  }, [completeLogin]);

  const logout = useCallback(() => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("token");
    setUser(null);
  }, []);

  const setModule = useCallback((m) => {
    setModuleState(m);
    localStorage.setItem("module", m);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch { /* session expirée gérée par l'intercepteur */ }
  }, []);

  return (
    <AppCtx.Provider value={{ user, login, completeLogin, logout, module, setModule, refresh }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
